export enum NotificationType {
  FileNotification = 'FILE_NOTIFICATION',
  FileDeletion = 'FILE_DELETION',
}
